export const USER_GENERATED_CONTENT = "userGeneratedContent";
export const COMMUNITY = "community";
export const MANAGE_UNI_ADMINS = "manageUniAdmins";
export const ENABLE_DEGREE_TYPES = "enableDegreeTypes";
export const COMMUNITY_STAND_ALONE = "communityStandAlone";
